import React from 'react';
import PropTypes from 'prop-types';

import Skeleton from 'react-loading-skeleton';

const LoadingTemplate = () => <Skeleton circle />;

LoadingTemplate.propTypes = {};

export default LoadingTemplate;
